import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, { InputDateField } from '../../../../../utils/InputField';
import { GetFloatNumber } from '../../../../../utils/NumberFormatter';
import { handleCreateSubscription } from '../../InvoiceOperation';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function Pricing({ price }) {
    return (
        <div className="flex flex-row justify-start items-center gap-1 text-primary-700">
            <span className="whitespace-nowrap">Price:</span>
            <span className="text-primary font-medium">{GetFloatNumber(price)}</span>
        </div>
    );
}
function ProductType({ type }) {
    return (
        <div className="flex flex-row justify-start items-center gap-1 text-primary-700 mb-3">
            <span className="whitespace-nowrap">Product Type:</span>
            <span className="text-primary font-medium capitalize">{type}</span>
        </div>
    );
}

function ProductDetails({ data }) {
    return (
        <div className="content-part flex flex-col gap-1 items-start overflow-hidden mb-2 border-b pb-2 w-full">
            {/* <div className="w-11 min-w-[44px]  h-11">
                <img src={data.logoUrl || menuIcon.settingsWL} alt="" className="w-full block" />
            </div> */}
            <div className="flex flex-row items-center gap-3">
                <span className="inline-block text-primary text-lg font-medium">
                    {data?.productTitle}
                </span>
            </div>
            <p className="text-sm text-primary-700">{data?.productDescription}</p>
        </div>
    );
}

function CreateSubscriptionModal({ data }) {
    const { handleReload } = useInvoiceInfo();
    const { closeModal } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        domain: data?.domain,
        goLiveDate: dayjs().format('YYYY-MM-DD')
    });

    const { invoiceId } = useParams();
    // // handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((d) => ({ ...d, [name]: value }));
    };
    const { setMessage } = useTemplate();

    const handleOnSubmit = (e) => {
        e.preventDefault();
        const payload = {
            invoiceId,
            domain: formData?.domain,
            goLiveDate: formData?.goLiveDate
        };
        setLoading(true);
        handleCreateSubscription(invoiceId, data?.id, payload, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                handleReload();
                closeModal();
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleOnSubmit}>
            <div className="flex flex-col overflow-hidden transition-all duration-500">
                <div>
                    <ProductDetails data={data} />
                    <Pricing price={data?.totalPrice} />
                    <ProductType type={data?.productType} />
                </div>

                <div className="mb-4">
                    <InputDateField
                        label="Go Live Date (approx.)"
                        name="goLiveDate"
                        // placeholder="Type domain..."
                        formData={formData}
                        onChange={handleChange}
                    />
                </div>
                <div className="mb-4">
                    <InputField
                        label="Domain"
                        name="domain"
                        placeholder="Type domain..."
                        formData={formData}
                        onChange={handleChange}
                        optional
                    />
                </div>

                <div className="w-full flex justify-end items-center gap-2 mb-2">
                    <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                    <ButtonPrimary title="Create" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default CreateSubscriptionModal;
